import { render } from "./MoviesSearch.vue?vue&type=template&id=d3991bf4&scoped=true"
import script from "./MoviesSearch.vue?vue&type=script&lang=js"
export * from "./MoviesSearch.vue?vue&type=script&lang=js"

import "./MoviesSearch.vue?vue&type=style&index=0&id=d3991bf4&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3991bf4"]])

export default __exports__